import { default as b2uhVl8mou2lMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/b2.vue?macro=true";
import { default as build_pre7PIofFi3CLMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/build_pre.vue?macro=true";
import { default as buildYxLW1rauE7Meta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/build.vue?macro=true";
import { default as _91_46_46_46slug_93F9ik0Wn9lAMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/[...slug].vue?macro=true";
import { default as oldhIi6wCJbL9Meta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/old.vue?macro=true";
import { default as utilsQ8y9qUwU20Meta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/utils.ts?macro=true";
import { default as indexuuWTud9l7FMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/index.vue?macro=true";
import { default as montest6yQgf9VbvyMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/montest.vue?macro=true";
import { default as progepNiq8UEOgMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/prog.vue?macro=true";
import { default as _91_46_46_46slug_93XfXqVnZCeuMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/project/[...slug].vue?macro=true";
import { default as projectsdbl9H7m4gIMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/projects.vue?macro=true";
import { default as holdlD0lo0fswkMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/share/hold.js?macro=true";
import { default as _91_46_46_46slug_93uWIaqz7ol7Meta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/[...slug].vue?macro=true";
import { default as oldb0CVuyHfxIMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/old.vue?macro=true";
import { default as utils2j1wXmzZDPMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/utils.ts?macro=true";
import { default as testzuryTl33DsMeta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/test.vue?macro=true";
import { default as vscB6WpPem8j1Meta } from "/Users/jdo/org/brx/mcp/mcp-frontend/pages/vsc.vue?macro=true";
export default [
  {
    name: "b2",
    path: "/b2",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/b2.vue")
  },
  {
    name: "build_pre",
    path: "/build_pre",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/build_pre.vue")
  },
  {
    name: "build",
    path: "/build",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/build.vue")
  },
  {
    name: "codeBrk-slug",
    path: "/codeBrk/:slug(.*)*",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/[...slug].vue")
  },
  {
    name: "codeBrk-old",
    path: "/codeBrk/old",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/old.vue")
  },
  {
    name: "codeBrk-utils",
    path: "/codeBrk/utils",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/codeBrk/utils.ts")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/index.vue")
  },
  {
    name: "montest",
    path: "/montest",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/montest.vue")
  },
  {
    name: "prog",
    path: "/prog",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/prog.vue")
  },
  {
    name: "project-slug",
    path: "/project/:slug(.*)*",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/project/[...slug].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/projects.vue")
  },
  {
    name: "share-hold",
    path: "/share/hold",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/share/hold.js")
  },
  {
    name: "skyfire-slug",
    path: "/skyfire/:slug(.*)*",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/[...slug].vue")
  },
  {
    name: "skyfire-old",
    path: "/skyfire/old",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/old.vue")
  },
  {
    name: "skyfire-utils",
    path: "/skyfire/utils",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/skyfire/utils.ts")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/test.vue")
  },
  {
    name: "vsc",
    path: "/vsc",
    component: () => import("/Users/jdo/org/brx/mcp/mcp-frontend/pages/vsc.vue")
  }
]